<template>
    <b-modal id="user_other" ref="user_other" @hidden="resetModal"
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            <div v-if="mode === 'status'">
                Update Status for<br>
                <div class="text-primary"> {{user.data.attributes.name}}</div>
            </div>

            <div v-if="mode === 'comment' || edit">
                {{ !edit ? 'Add' : 'Edit' }} comment for<br>
                <div class="text-primary"> {{user.data.attributes.name}}</div>
            </div>
        </template>

        <div v-if="mode === 'status'" class="d-flex flex-row mb-4">
            <span class="iconsminds-power-2 mr-3 menu-icon-style"/>

            <p class="my-auto">Status lorem You can not change the status as INACTIVE if any unit(s) is/are
                occupied.
                Please discharge the user(s) before changing the STATUS!
            </p>
        </div>

        <div v-if="mode === 'comment'" class="d-flex flex-row mb-4">
            <span class="iconsminds-speach-bubbles mr-3 menu-icon-style"/>

            <p class="my-auto">Comment lorem You can not change the status as INACTIVE if any unit(s) is/are
                occupied.
                Please discharge the user(s) before changing the STATUS!
            </p>
        </div>

        <b-form>
            <b-row v-if="mode === 'status'">
                <b-colxx v-if="form.status" xxs="12" class="mb-4">
                    <h6>
                        <b-badge class="w-100" :variant="'outline-' + userStatusColor(form.status)">
                            The User will be {{ form.status.toUpperCase() }} after submission!
                        </b-badge>
                    </h6>
                </b-colxx>

                <b-colxx md="12" class="mb-2">
                    <b-form-group label="Type" class="has-float-label">
                        <template v-slot:label>
                            <span>Change Status <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateStatus" v-model="selected.status" :options="status"
                                  :border-danger="'type' in errors"/>

                        <b-form-invalid-feedback :state="!'type' in errors"
                                                 v-text="'type' in errors ? errors.type[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Comment" class="has-float-label">
                        <template v-slot:label>
                            <span>Comment <sup><code>*</code></sup></span>
                        </template>

                        <b-form-textarea v-model="form.comment" rows="6"
                                         @input="'comment' in errors ? (delete errors.comment) : ''"
                                         placeholder="Comment"/>

                        <b-form-invalid-feedback :state="!('comment' in errors)"
                                                 v-text="'comment' in errors ? errors.comment[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('user_other')" v-text="'Cancel'"/>

            <template v-if="currentStatus === form.status">
                <b-button variant="primary" v-if="!edit && (mode === 'status' || mode === 'comment')" disabled v-text="'Submit'"/>
            </template>

            <template v-else>
                <state-button variant="primary" v-if="!edit && (mode === 'status' || mode === 'comment')" :click="submitUserOther">
                    Submit
                </state-button>
            </template>

            <state-button variant="primary" v-if="edit" :click="updateUserComment">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
import {mapGetters} from "vuex";
import StateButton from "../../../../components/Common/StateButton";

export default {
    name: "UserOtherModal",

    components: {
        StateButton,
    },

    props: [
        'user', 'mode', 'edit'
    ],

    data() {
        return {
            status: [
                {label: 'Active', value: 'Active'},
                {label: 'Inactive', value: 'Inactive'},
                {label: 'Offline', value: 'Offline'},
            ],
            selected: {
                status: [],
            },
            currentStatus: this.user.data.attributes.status || null,
        }
    },

    mounted() {
        this.selected.status = [
            {
                label: this.user.data.attributes.status,
                value: this.user.data.attributes.status,
            }
        ];
    },

    watch: {
        user() {
            this.selected.status = [
                {
                    label: this.user.data.attributes.status,
                    value: this.user.data.attributes.status,
                }
            ];
        },
    },

    computed: {
        ...mapGetters({
            form: 'getUserOtherForm',
            errors: 'getUserErrors',
        }),
    },

    methods: {
        resetModal() {
            this.$emit('close');
            this.$store.commit('setUserOtherForm');
        },

        userStatusColor: status => {
            if (status === 'Active') return 'info'
            else if (status === 'Inactive') return 'danger'
            else if (status === 'Offline') return 'warning'
        },

        updateStatus(field) {
            if (field) {
                this.form.status = field.value;
            } else {
                this.form.status = '';
            }
            'status' in this.errors ? delete this.errors.status : '';
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        submitUserOther() {
            return new Promise((success, fail) => {
                if (this.mode === 'status') this.$store.dispatch('submitUserStatus', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetModal();

                            this.$notify('success filled', 'Success!', 'Status updated!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('user_other');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
                else if (this.mode === 'comment') this.$store.dispatch('submitUserComment', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetModal();

                            this.$notify('success filled', 'Success!', 'New comment added!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('user_other');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            });
        },

        updateUserComment() {
            return new Promise((success, fail) => {
                this.$store.dispatch('updateUserComment', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetModal();

                            this.$notify('success filled', 'Success!', 'Comment Updated!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('user_other');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            });
        },
    }
}
</script>

<style scoped>

</style>
